import { createSelector } from 'reselect';
import { getClubsSelector } from './selector/get-clubs.selector';
import { ClubView } from './view/club.view';
import { ClubWebsiteView } from './view/club-website.view';
import { ClubCategoryView } from './view/club-category.view';

export const ClubsPresenter = createSelector(
  [getClubsSelector],
  (clubs): ClubView[] => {
    return clubs
      .filter((club) => club.longitude && club.latitude)
      .map(
        (club) =>
          ({
            item: club,
            id: club.id,
            name: club.name,
            notes: club.notes,

            contact: club.contact,
            members: club.members,
            meets: club.meets,
            country: club.country,
            websites: club.websites.map(
              (w) =>
                ({
                  id: w.id,
                  link: w.link,
                }) satisfies ClubWebsiteView as ClubWebsiteView,
            ),
            categories: club.categories.map(
              (c) =>
                ({
                  id: c.id,
                  categoryId: c.categoryId,
                  name: c.name,
                }) satisfies ClubCategoryView as ClubCategoryView,
            ),

            location: club.location,
            latitude: club.latitude!,
            longitude: club.longitude!,
          }) satisfies ClubView as ClubView,
      )
      .sort((a, b) => {
        const compareCountry = a.country.localeCompare(b.country);
        if (compareCountry !== 0) {
          return compareCountry;
        }

        return a.name.localeCompare(b.name);
      });
  },
);
